import { enumToStaticValue } from '@/utils'
import { IncomeStockMovementType } from './incomeStockMovementType'

export default enumToStaticValue(IncomeStockMovementType, 'income-stock-movement-type')
